// extracted by mini-css-extract-plugin
export default {"target_product":"Fca","retake":"Gca","product_info":"Hca","icon":"Ica","target_image":"Jca","background":"Kca","product_info_desktop":"Lca","info":"Mca","title":"Nca","benefits":"Oca","benefit":"Pca","accordeon_wrapper":"Qca","ingredients_wrapper":"Rca","info_wrapper":"Sca","product_wrapper":"Tca"};
    if(module.hot) {
      // 1726593108487
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  